module.exports = __webpack_public_path__ + "img/Sivamani2.e83aa641.jpeg";